const config = {
    bucketName: process.env.REACT_APP_AWS_BUCKET_NAME,
    region:'us-east-1',
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY_SECRET,
    dirName:"jumunona_products"
}

export default config;


export const categoryConfig = {
    bucketName: process.env.REACT_APP_AWS_BUCKET_NAME,
    region:'us-east-1',
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY_SECRET,
    dirName:"categories"
}